var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 180,
    viewBox: "0 0 181 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clock",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.2,
    d: "M90.5 180C140.206 180 180.5 139.706 180.5 90C180.5 40.2944 140.206 0 90.5 0C40.7944 0 0.5 40.2944 0.5 90C0.5 139.706 40.7944 180 90.5 180Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M90.5002 172.936C136.305 172.936 173.438 135.804 173.438 89.9989C173.438 44.1938 136.305 7.06152 90.5002 7.06152C44.6952 7.06152 7.56287 44.1938 7.56287 89.9989C7.56287 135.804 44.6952 172.936 90.5002 172.936Z",
    fill: "#B3E5F4",
    stroke: "#263238",
    strokeWidth: 1.60862,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M90.4995 92.7131C90.1377 92.7153 89.7792 92.6448 89.4453 92.5056C89.1113 92.3665 88.8088 92.1616 88.5557 91.9031L36.3877 38.3259C35.9114 37.8057 35.6563 37.1204 35.6767 36.4153C35.697 35.7102 35.9912 35.0407 36.4967 34.5488C37.0023 34.0569 37.6796 33.7813 38.385 33.7803C39.0904 33.7793 39.7684 34.053 40.2754 34.5435L92.4514 88.0802C92.8245 88.4624 93.0764 88.9461 93.1758 89.4708C93.2751 89.9955 93.2173 90.5379 93.0098 91.03C92.8023 91.522 92.4541 91.9419 92.009 92.2369C91.5639 92.532 91.0416 92.6892 90.5076 92.6888L90.4995 92.7131Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.2,
    d: "M67.0979 108.369C66.5141 108.372 65.945 108.186 65.4751 107.84C65.0053 107.494 64.6596 107.005 64.4895 106.447C64.3195 105.888 64.334 105.29 64.5311 104.74C64.7281 104.191 65.0971 103.719 65.5833 103.396L88.9904 87.7402C89.5887 87.3614 90.3114 87.2315 91.0042 87.3783C91.697 87.525 92.3049 87.9368 92.6982 88.5257C93.0915 89.1146 93.239 89.8339 93.1092 90.5301C92.9793 91.2262 92.5825 91.844 92.0034 92.2515L68.6044 107.908C68.1587 108.207 67.6346 108.367 67.0979 108.369Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M93.865 89.9992C93.8666 89.3341 93.6709 88.6834 93.3025 88.1296C92.9341 87.5758 92.4097 87.1437 91.7957 86.8881C91.1817 86.6324 90.5056 86.5647 89.853 86.6935C89.2005 86.8223 88.6008 87.1417 88.1299 87.6115C87.659 88.0812 87.3381 88.6802 87.2078 89.3324C87.0774 89.9846 87.1435 90.6609 87.3977 91.2755C87.6518 91.8902 88.0826 92.4156 88.6356 92.7853C89.1885 93.155 89.8387 93.3523 90.5038 93.3523C91.3938 93.3523 92.2476 92.9993 92.8777 92.3707C93.5078 91.7421 93.8629 90.8893 93.865 89.9992Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.60862,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M90.5632 14.4814V25.691",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M90.5632 153.434V164.643",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M165.646 89.5635H154.428",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.6949 89.5635H15.4854",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M129.935 25.6338L124.055 35.1829",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M57.0666 143.941L51.1865 153.491",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M156.617 53.8691L146.752 59.1985",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M34.3715 119.929L24.5065 125.258",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M154.49 128.943L144.941 123.055",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M36.1843 56.0715L26.6351 50.1914",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M126.257 155.621L120.928 145.748",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M60.2038 33.3787L54.8744 23.5137",
    stroke: "#263238",
    strokeWidth: 3.21723,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.75b7bd9078eca7deb2df315f709b8619.svg";
export { ForwardRef as ReactComponent };